"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoarEffectHandler = exports.RoarEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RoarEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Roar;
        this.__typeName = "Roar";
        this.name = "Roar";
        this.harmful = false;
    }
}
exports.RoarEffectArgs = RoarEffectArgs;
let RoarEffectHandler = class RoarEffectHandler {
    apply(sequence, container, state) {
        const increaseBy = Math.round(0.5 * container.getLevel(state.targetId));
        state.meta.buffIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, increaseBy),
                },
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Focus, increaseBy),
                },
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, increaseBy),
                }
            ],
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.buffIds.forEach(id => container.cancelEffect(sequence, id));
    }
};
RoarEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Roar)
], RoarEffectHandler);
exports.RoarEffectHandler = RoarEffectHandler;
